import { Icon } from '@/components/ui/Icon'
import type { DismissReason } from '@/types'
import { DISMISS_REASONS, REASON_BY_ID } from './DismissButton'

interface UndoDismissToastProps {
  title: string
  confirmedReason: DismissReason | null
  onUndo: () => void
  onPickReason: (reason: DismissReason) => void
}

export function UndoDismissToast({
  title,
  confirmedReason,
  onUndo,
  onPickReason,
}: UndoDismissToastProps) {
  return (
    <div className="cg-undo-toast" role="status" aria-live="polite">
      <div className="cg-undo-toast-row">
        <div className="cg-undo-toast-icon">
          <Icon name="eye-off" size={14} />
        </div>
        <div className="cg-undo-toast-body">
          <div className="cg-undo-toast-title">
            Hid <strong>{title}</strong> from your recommendations
          </div>
          {!confirmedReason ? (
            <div className="cg-undo-toast-sub">Tell us why and we'll learn from it — or undo.</div>
          ) : (
            <div className="cg-undo-toast-sub">
              {REASON_BY_ID[confirmedReason].confirmation}{' '}
              <span className="cg-undo-toast-tag">{REASON_BY_ID[confirmedReason].label}</span>
            </div>
          )}
        </div>
        <button type="button" className="cg-btn ghost tiny" onClick={onUndo}>
          Undo
        </button>
      </div>
      {!confirmedReason && (
        <div className="cg-undo-toast-reasons">
          {DISMISS_REASONS.map((r) => (
            <button
              key={r.id}
              type="button"
              className="cg-reason-chip"
              onClick={() => onPickReason(r.id)}
            >
              {r.label}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
